<template>
  <v-card>
    <v-toolbar color="secondary" class="elevation-0">
      <v-toolbar-title> Quotas </v-toolbar-title>
    </v-toolbar>
    <v-card-actions>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        outlined
        dense
        hide-details
      ></v-text-field>
    </v-card-actions>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :disable-pagination="!!tenant_uid"
        disable-sort
        dense
        :items-per-page="15"
        :search="search"
      >
        <template v-slot:[`item.rollover`]="{ item }">
          <v-icon v-if="item.rollover"> mdi-check </v-icon>
          <v-icon v-if="!item.rollover"> mdi-close </v-icon>
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-btn icon @click="showDetails(item)">
            <v-icon>mdi-clipboard-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="detailsDialog" width="500">
      <v-card>
        <v-toolbar color="secondary" class="elevation-0">
          <v-toolbar-title>
            {{ this.item?.tenant }} - {{ this.item?.code }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5 px-5">
          <pre class="text-body-1">{{
            JSON.stringify(this.item?.details, null, 2)
          }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalise } from "@/lib/utils";

export default {
  props: ["tenant_uid"],

  data: () => ({
    loading: false,
    detailsDialog: false,
    item: null,
    search: null,
    headers: [
      { text: "Code", value: "code" },
      { text: "Quota", value: "quota" },
      { text: "Tenant", value: "tenant" },
      { text: "Subscription", value: "subscription" },
      { text: "Rollover", value: "rollover" },
      { text: "Details", value: "details" },
    ],
  }),

  watch: {
    detailDialog(val) {
      if (!val) this.item = null;
    },
  },

  computed: {
    ...mapGetters(["quotas", "tenants", "subscriptions"]),
    items() {
      return this.quotas
        ?.filter((q) => !this.tenant_uid || q.tenant_uid === this.tenant_uid)
        .map((q) => ({
          code: capitalise(q.quota_code),
          quota: q.value,
          tenant: this.tenants?.find((t) => t.uid === q.tenant_uid)?.name,
          subscription: this.subscriptions?.find(
            (s) => s.uid === q.subscription_uid
          )?.plan_code,
          rollover: q.rollover,
          details: q,
        }));
    },
  },

  methods: {
    showDetails(item) {
      this.item = item;
      this.detailsDialog = true;
    },
    openDetail(item) {
      this.$router.push("/instances/" + item.details.uid);
    },
  },
};
</script>
